import type { ConditionConfiguration } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import { ConditionEqualityType } from "../../../../../../../../api/types/fieldConfigurationTypes.ts";
import type {
  BuildExportRequest,
  DimensionDescriptor,
  ExportConfig,
  ExportParameters,
  RunExportRequest,
} from "../../../../../../../../api/types/svTypes.ts";

const buildParameters = (
  conditions: ConditionConfiguration[],
  dimensions: DimensionDescriptor[]
): ExportParameters[] => {
  return conditions
    .filter((c) => c.parameter === true && c.invalid !== true)
    .map((c) => ({
      name:
        c.customLabel ||
        c.systemLabel ||
        dimensions.find((d) => d.name === c.filter.dimensionName)?.caption ||
        c.filter.dimensionName,
      equality: c.filter.equalityType ?? ConditionEqualityType.Equal,
      values: c.filter.values,
    }));
};

const buildExportConfig = (
  conditions: ConditionConfiguration[],
  dimensions: DimensionDescriptor[],
  withParameters: boolean,
  exportValuesAsDisplayed?: boolean
): ExportConfig => {
  return {
    withParameters,
    parameters: buildParameters(conditions, dimensions),
    exportValuesAsDisplayed,
  };
};

export const createBuildExportRequest = (
  buildConfig: BuildExportRequest["buildConfig"],
  dimensions: DimensionDescriptor[],
  withParameters: boolean,
  exportValuesAsDisplayed?: boolean
): BuildExportRequest => ({
  buildConfig,
  exportConfig: buildExportConfig(buildConfig.conditions, dimensions, withParameters, exportValuesAsDisplayed),
});

export const createRunExportRequest = (
  viewConfig: RunExportRequest["viewConfig"],
  dimensions: DimensionDescriptor[],
  withParameters: boolean,
  exportValuesAsDisplayed?: boolean
): RunExportRequest => ({
  viewConfig,
  exportConfig: buildExportConfig(viewConfig.conditions, dimensions, withParameters, exportValuesAsDisplayed),
});
